import { render } from "./OurLeadership.vue?vue&type=template&id=74b72ef7&scoped=true"
import script from "./OurLeadership.vue?vue&type=script&lang=js"
export * from "./OurLeadership.vue?vue&type=script&lang=js"

import "./OurLeadership.vue?vue&type=style&index=0&id=74b72ef7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b72ef7"]])

export default __exports__